/* RESPONSIBLE TEAM: team-omni */
/* === ⚠️ THIS FILE CURRENTLY USES DEPRECATED PATTERNS ⚠️ === */
/* === 🔗 For more information visit https://go.inter.com/ember-best-practices 🔗 */
/* === 🚀 Please consider refactoring & removing some of the comments below when working on this file 🚀 */
/* eslint-disable @intercom/intercom/no-bare-strings */
import { buildValidations, validator } from 'ember-cp-validations';

export default buildValidations({
  jsonBlocks: {
    description: 'Localized WhatsApp message content',
    validators: [
      validator('presence', {
        presence: true,
        message: 'Content should not be empty',
      }),
      validator('title-and-body-blocks-not-empty', {
        message: 'WhatsApp message content should not be empty',
      }),
    ],
  },
});
